function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.04 19.93H7.12a1.42 1.42 0 110-2.85h14.86a4.27 4.27 0 004.14-3.23l2.35-9.24a1.41 1.41 0 00-1.42-1.76H6.77a4.27 4.27 0 00-4-2.85H1.41a1.42 1.42 0 000 2.85h1.34a1.42 1.42 0 011.42 1.08l.09.68 2.46 9.62a4.27 4.27 0 00.39 8.54h.25a4.27 4.27 0 108.03 0h3.36a4.27 4.27 0 108.03 0h.25a1.42 1.42 0 000-2.84zM25.22 5.69l-1.86 7.46a1.42 1.42 0 01-1.43 1.08H9.65L7.52 5.7h17.7zM11.4 25.62a1.42 1.42 0 111.42-1.42 1.42 1.42 0 01-1.42 1.42zm11.38 0a1.42 1.42 0 111.43-1.42 1.42 1.42 0 01-1.43 1.42z",
  fill: "#fff"
});

var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.51,
    height: 28.5
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ShoppingCart.7b712e03.svg";
export { SvgShoppingCart as ReactComponent };